class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    const isIntersecting = entries.some(entry => entry.target === this && entry.isIntersecting)
    if (!isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {

        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initCarouselDots();
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  // Pagination dots for the mobile cross-sell carousel (2026 CI).
  // Hidden on desktop via CSS; the active dot follows the scroll-snap position.
  initCarouselDots() {
    const slider = this.querySelector('.mini-cart__navigation');
    if (!slider) return;

    this.querySelector('.cart-recommendations__dots')?.remove();
    const slides = Array.from(slider.querySelectorAll(':scope > li'));
    if (slides.length < 2) return;

    const origin = slides[0].offsetLeft;
    const dotsWrapper = document.createElement('div');
    dotsWrapper.className = 'cart-recommendations__dots';

    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      if (index === 0) dot.classList.add('is-active');
      dot.setAttribute('aria-label', `${index + 1} / ${slides.length}`);
      dot.addEventListener('click', () => {
        slider.scrollTo({ left: slide.offsetLeft - origin, behavior: 'smooth' });
      });
      dotsWrapper.appendChild(dot);
      return dot;
    });

    this.appendChild(dotsWrapper);

    let ticking = false;
    slider.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        let activeIndex = 0;
        let minDistance = Infinity;
        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - origin - slider.scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
      });
    }, { passive: true });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
